import React, { useState, useEffect } from "react";
import { Grid, Button, TextField, Alert, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

const Usermodify = (props) => {
  const [open, setOpen] = React.useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // Reset all state values when closing the dialog
    setState({
      username: "",
      groups: [],
      password: "",
      password2: "",
      errorMessage: "",
      right: false,
      radioList: "A",
      active: "1",
      emailError: false,
      passwordError: false,
      passwordMatchError: false,
    });
    setIsFormValid(false); // Reset form validation state
  };

  const [state, setState] = React.useState({
    username: "",
    groups: [],
    password: "",
    password2: "",
    errorMessage: "",
    right: false,
    radioList: "A",
    active: "1",
    emailError: false,
    passwordError: false,
    passwordMatchError: false,
  });

  // Validate form whenever state changes
  useEffect(() => {
    validateForm();
  }, [state]);

  const validateForm = () => {
    const { username, password, password2, groups } = state;
    
    // Check if all required fields are filled
    const isUsernameValid = username.trim() !== "";
    const isPasswordValid = password !== "" && password2 !== "" && password === password2;
    const isGroupsValid = groups.length > 0;
    
    // Enable button only if all validations pass
    setIsFormValid(isUsernameValid && isPasswordValid && isGroupsValid);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    if (state.password !== state.password2) {
      setState({ errorMessage: "The passwords doesn't match" });
    } else {
      const register = {
        username: state.username,
        password: state.password,
        groups: state.groups.toString(),
        active: state.active,
      };
      const UserID = props.UserID;
      fetch(
        `${process.env.REACT_APP_API_URL}/api/user_management/user/${UserID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(register),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          window.location.reload();
        });
    }
  };
  

  const handleChange = (e) => {
    const { id, value } = e.target;
    // Validation for password fields
    if (id === "password" || id === "password2") {
      const passwordValid = value.length >= 8; // Minimum 8 characters
      const passwordsMatch = id === "password"
        ? value === state.password2
        : value === state.password;
                
      setState(prev => ({
        ...prev,
        [id]: value,
        passwordError: !passwordValid,
        passwordMatchError: !passwordsMatch
      }));
    }
    // For other fields
    else {
      setState(prev => ({
        ...prev,
        [id]: value
      }));
    }
  };

  const [userlist, setusers] = useState([]);

  useEffect(() => {
    if (!open) return; // Only fetch data when dialog is open
    
    var UserID = props.UserID;
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/user_list/${UserID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          localStorage.setItem("user_access", data.detail);
        } else {
          setusers(data);
          // Pre-fill form with existing user data
          setState(prevState => ({
            ...prevState,
            username: data.username || "",
            groups: data.groups || [],
            active: data.active || "1"
          }));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [props.UserID, open]); // Add open as dependency

  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  return (
    <>
      <Tooltip title="Edit User" arrow>
        <IconButton aria-label="edit" onClick={handleClickOpen}>
          <EditIcon style={{ color: "#009688" }} />
        </IconButton>
      </Tooltip>

      <div style={{ alignItems: "center", display: "flex" }}>
        <div>
          {state.errorMessage && (
            <Alert color="danger" isOpen={visible} toggle={onDismiss}>
              {" "}
              {state.errorMessage}{" "}
            </Alert>
          )}
        </div>
        <Dialog
          open={open}
          onClose={(event, reason) => {
            // Only allow closing through the cancel button
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return;
            }
            handleClose();
          }}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">EDIT USER</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              placeholder={userlist.email}
              type="email"
              fullWidth
              name="email"
              value={state.email}
              onChange={handleChange}
              autoComplete="new-email"
              for="email"
              InputProps={{
                readOnly: true,
              }}
              required
            />
            <TextField
              for="username"
              id="username"
              autoFocus
              margin="dense"
              type="text"
              fullWidth
              placeholder={userlist.username}
              value={state.username}
              onChange={handleChange}
              name="username"
              required
              error={state.usernameError}
              helperText={state.usernameError ? "Special characters are not allowed" : ""}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Password*"
              fullWidth
              for="password"
              type="password"
              autoComplete="new-password"
              name="password"
              id="password"
              value={state.password}
              onChange={handleChange}
              required
              error={state.passwordError}
              helperText={state.passwordError ? "Password must be at least 8 characters" : ""}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Confirm Password*"
              fullWidth
              for="password2"
              type="password"
              autoComplete="new-password"
              name="password2"
              id="password2"
              value={state.password2}
              onChange={handleChange}
              required
              error={state.passwordMatchError}
              helperText={state.passwordMatchError ? "Passwords do not match" : ""}
            />
          </DialogContent>
          <DialogContent>
            <Grid item md={13} xs={12}>
              <TextField
                fullWidth
                name="groups"
                id="groups"
                value={state.groups}
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                variant="outlined"
              >
                {parseInt(userlist.groups) === 1 ? (
                  <React.Fragment>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                    <option value="3">OPS</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 2 ? (
                  <React.Fragment>
                    <option value="2">Read-Only</option>
                    <option value="1">Admin</option>
                    <option value="3">OPS</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 3 ? (
                  <React.Fragment>
                    <option value="3">OPS</option>
                    <option value="1">Admin</option>
                    <option value="2">Read-Only</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 4 ? (
                  <React.Fragment>
                    <option value="4">Trainer</option>
                  </React.Fragment>
                ) : parseInt(userlist.groups) === 5 ? (
                  <React.Fragment>
                    <option value="5">Trainee</option>
                  </React.Fragment>
                ): (
                  ""
                )}
              </TextField>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel" arrow>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="Update" arrow>
              <span>
                <Button 
                  type="submit" 
                  onClick={handleSubmitClick} 
                  color="primary"
                  disabled={!isFormValid}
                >
                  Update
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Usermodify;